<template>
  <div class="relative">
    <button
        type="button"
        class="flex items-center justify-between w-full h-11 px-3 border border-stroke-separator rounded-lg bg-transparent text-text-neutral-extreme outline-none focus:border-elements-blue cursor-pointer"
        @click="open = !open"
    >
      <span class="flex items-center gap-2">
        <img v-if="props.showFlags" :src="'/data/flags/' + props.modelValue + '.png'" class="w-4 h-4 rounded-full overflow-hidden" alt="" />
        {{ languageName }}
      </span>
      <img src="@/assets/icons/chevron-down-white.svg" class="w-4 h-4" alt="" />
    </button>

    <div
        v-if="open"
        class="absolute z-20 mt-2 w-full max-w-[320px] bg-layer-2 border border-stroke-separator rounded-lg shadow-lg p-3"
    >
      <language-picker :initial="props.modelValue" :close-on-select="false" :show-flags="props.showFlags" @select="onSelect"></language-picker>
    </div>
    <div v-if="open" class="fixed inset-0 z-10" @click="open = false"></div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, defineProps, defineEmits, withDefaults } from 'vue'
import LanguagePicker from '@/components/session/LanguagePicker.vue'
import { useLanguages } from '@/composables/useLanguages'

// showFlags: flags on the button and in the list, as in the room's language picker.
const props = withDefaults(defineProps<{ modelValue: string, showFlags?: boolean }>(), {
  showFlags: false,
})
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
const emit = defineEmits<{ (event: 'update:modelValue', code: string): void }>()

const { getLanguageName } = useLanguages()

const open = ref(false)
const languageName = computed(() => getLanguageName(props.modelValue))

function onSelect(code: string) {
  emit('update:modelValue', code)
  open.value = false
}
</script>
